import aavyaTheme from "@aavya/theme/index";
import $ from "jquery";

export default function () {
    const arrow = '<svg fill="#000000" viewBox="0 0 129 129"><path d="M121.3 34.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z"/></svg>';
    $('.homepage-slider .main-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: true,
        dots: true,
        prevArrow: arrow,
        nextArrow: arrow,
        autoplay: true,
        autoplaySpeed: 5000,
    });

    $('.homepage-slider .nav-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.main-carousel',
        centerMode: true,
        fade: true,
        focusOnSelect: true,
        arrows: false,
        dots: false
    });

    $('.homepage-slider .nav-carousel .carousel-item').on('click', function (e) {
        e.preventDefault();
        $('.homepage-slider .nav-carousel').slick('slickNext');
    });

    $('.homepage-slider .nav-carousel .carousel-item .content-wrapper a').on('click', function (e) {
        e.preventDefault();
        console.log($(this).attr('href'));
        location = $(this).attr('href');
    });

    $('.tab-section .tab-content').each(function () {
        $(this).find('.product-carousel').slick({
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            infinite: true,
            draggable: true,
            dots: false,
            responsive: [
                {
                  breakpoint: 767,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
            ]
        });
    })

    $('.tabs .tab-item').on('click', function (e) {
        e.preventDefault();
        $('.tabs .tab-item').removeClass('active');
        $(this).addClass('active');
        var id = $(this).attr('href');
        $('.tab-section .tab-content').removeClass('active');
        $('.tab-section').find(id).addClass('active'); 
    })
}
